import React from "react";

const ErrorBoundaryFallback = ({
  title = "Something went wrong",
  message = "This section crashed. You can try again without reloading the whole app.",
  onRetry,
  showReload = true,
}) => {
  return (
    <div className="flex min-h-[220px] w-full items-center justify-center p-4">
      <div className="w-full max-w-xl rounded-xl border border-red-200 bg-red-50 px-6 py-5 text-center text-red-900 shadow-sm">
        <h2 className="text-lg font-semibold">{title}</h2>
        <p className="mt-2 text-sm text-red-700">{message}</p>

        <div className="mt-5 flex flex-wrap items-center justify-center gap-3">
          <button
            type="button"
            onClick={onRetry}
            className="rounded-full bg-red-600 px-4 py-2 text-sm font-medium text-white transition hover:bg-red-700"
          >
            Try again
          </button>

          {showReload ? (
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="rounded-full border border-red-300 bg-white px-4 py-2 text-sm font-medium text-red-800 transition hover:bg-red-100"
            >
              Reload app
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ErrorBoundaryFallback;
